import React from "react";
import linksImg from "../../Assets/social_links.svg";

function SocialLiksImg() {
  return <img className="socialLinksImg" src={linksImg} alt="" />;
}

export default SocialLiksImg;
